// AUTHORITATIVE en source dictionary — HAND-MAINTAINED. Edit values in this file.
// ⛔ DO NOT run scripts/gen-i18n.mjs against this file. It is RETIRED as a writer:
//    it emits key lines only, so regenerating would DELETE 49 keys (35 of them bonus.*),
//    revert coinflip.practice_mode_banner, and erase every in-body comment below.
//    Historical origin: plans/cf-zh-keytable-v1.json (CF-ZH-L10N-V1) — inventory only, not a source.
// Gates: scripts/i18n-check.mts (key/placeholder parity) + tests/cf-bonus-i18n-semantics.spec.ts (semantics).
import type { Dict } from './core';

export const en: Dict = {
  'common.ton_unit': 'TON',
  'common.done_btn': 'Done',
  'common.close_btn': 'Close',
  'common.cancel_btn': 'Cancel',
  'common.retry_btn': 'Retry',
  'common.heads': 'HEADS',
  'common.tails': 'TAILS',
  'common.back_to_cricketflip': '← Back to CricketFlip',
  'app.brand_name': 'CricketFlip',
  'app.beta.badge': 'Live — private beta',
  'app.beta.tagline': 'A Standard win pays 2×. Every flip verifiable.',
  'app.beta.invite_only': 'Access is currently invite-only while we finish hardening.',
  'app.beta.notify_btn': 'Get launch notification',
  'app.beta.follow_note': 'Follow @cricketflip_official for launch announcement',
  'app.browser_gate.tagline': 'TON coin flip · Instant payouts',
  'app.browser_gate.subtagline': 'A Standard win pays 2×. Every flip verifiable with HMAC.',
  'app.browser_gate.play_btn': 'Play on Telegram',
  'app.browser_gate.exclusive_note': 'Available exclusively as a Telegram Mini App',
  'app.header.subtitle': 'Provably fair · Verifiable',
  'app.header.connect_wallet_btn': 'Connect Wallet',
  'app.wallet.connected_label': 'Connected',
  'app.wallet.onchain_balance_label': 'Wallet Balance',
  'app.wallet.address_label': 'Wallet Address',
  'app.wallet.ingame_balance_label': 'Cash Balance',
  'app.wallet.withdraw_btn': '💎 Withdraw cash · {amount} TON',
  'app.wallet.balance_unavailable': 'Temporarily unavailable',
  'app.wallet.checking_session': '⏳ Checking session...',
  'app.wallet.switch_btn': 'Switch',
  'app.wallet.disconnect_btn': 'Disconnect',
  'app.nav.flip': 'Flip',
  'app.nav.activity': 'Activity',
  'app.nav.leaders': 'Leaders',
  'app.nav.verify': 'Verify',
  'app.switch_warning.switch_title': 'Switch wallet?',
  'app.switch_warning.disconnect_title': 'Disconnect wallet?',
  'app.switch_warning.has_funds_body': 'Your {amount} TON balance is held in your CricketFlip account. Withdrawals are processed to your currently bound wallet — withdraw to this wallet first, or reconnect this same wallet later.',
  'app.switch_warning.unknown_balance_body': 'We can\'t confirm your CricketFlip balance right now. If it has funds, they remain in your account; reconnect to access them.',
  'app.switch_warning.withdraw_first_btn': 'Withdraw first',
  'app.switch_warning.switch_anyway_btn': 'Switch anyway',
  'app.switch_warning.disconnect_anyway_btn': 'Disconnect anyway',
  'boost.tier_selected_aria': '{label} selected; tap to revert to Standard',
  'boost.tier_select_aria': 'Select {label} tier; +{pct}% win, {fee} TON fee per TON staked',
  'boost.tier_label_pct': '{LABEL} +{pct}%',
  'boost.tier_fee_per_ton': 'Fee {fee} / TON',
  'coinflip.toast.not_enough_practice': 'Not enough practice credits!',
  'coinflip.toast.balance_updating': 'Your balance is updating — try again in a moment.',
  'coinflip.toast.chain_exhausted': 'All seeds in flight — try again in a moment.',
  'coinflip.toast.service_busy': 'Service is busy — please retry shortly.',
  'coinflip.toast.commit_failed': 'Could not start a flip. Try again.',
  'coinflip.toast.no_secure_random': 'Your browser does not support secure random. Use a modern browser.',
  'coinflip.toast.flip_in_flight': 'Another flip is still settling — wait a moment, then try again.',
  'coinflip.toast.commit_expired': 'Commit expired — tap FLIP again to get a fresh one.',
  'coinflip.toast.request_conflict': 'Request conflict — try again.',
  'coinflip.toast.insufficient_balance': 'Not enough balance for this stake.',
  'coinflip.toast.stake_out_of_range': 'Stake is outside the allowed range. Pick a smaller chip.',
  'coinflip.toast.maintenance': 'FLIP is paused for maintenance. Try again in a few minutes.',
  'coinflip.toast.hot_wallet_unconfigured': 'FLIP is being set up — try again shortly.',
  'coinflip.toast.hot_wallet_balance_unavailable': 'Brief network hiccup — tap FLIP again. Your balance is safe.',
  'coinflip.toast.insolvency_protection': 'Server is balancing exposure — tap FLIP again in a moment.',
  'coinflip.toast.flip_failed_safe': 'Flip failed. Your balance is safe — try again.',
  'coinflip.toast.failed_refunded': 'Flip failed during settlement; your stake was refunded.',
  'coinflip.toast.flip_incomplete': 'Flip could not be completed.',
  'coinflip.toast.unexpected_response': 'Unexpected server response. Please retry.',
  'coinflip.toast.connection_error': 'Connection error. Try again.',
  'coinflip.toast.something_wrong': 'Something went wrong. Try again.',
  'coinflip.toast.deposit_confirmed': 'Deposit confirmed! Start flipping 🪙',
  'coinflip.flipping': 'Flipping...',
  'coinflip.result.you_won': 'You Won',
  'coinflip.currency.credits': 'CREDITS',
  'coinflip.result.win_detail': '{OUTCOME} · {betAmount} {currency} × {mult}x',
  'coinflip.result.you_picked': 'You picked {choice}',
  'coinflip.result.loss_amount': '-{gross} {currency}',
  'coinflip.base_summary_bet': 'Bet',
  'coinflip.base_summary_win': 'Win',
  'coinflip.provably_fair_tagline': 'Every flip is provably fair',
  'coinflip.choose_again_btn': 'Choose Again',
  'coinflip.verify_btn': '✅ Verify',
  'coinflip.loading_session': 'Loading your session…',
  'coinflip.connecting': 'Connecting…',
  'coinflip.deposit_to_play_btn': 'Deposit to Play',
  'coinflip.withdraw_btn': 'Withdraw',
  'coinflip.add_funds_btn': '+ Add',
  'coinflip.practice_mode_banner': 'Free flip · Win real TON when you\'re ready',
  'coinflip.tap_to_flip_hero': 'TAP TO FLIP',
  'coinflip.tap_to_flip_aria': 'Tap to flip the coin',
  'coinflip.now_pick_side': 'Now pick your side',
  'coinflip.demo_upsell_title': 'Like the game? Play for real TON.',
  'coinflip.demo_upsell_sub': 'Same game. Real winnings. Withdraw anytime.',
  'coinflip.connect_wallet_deposit_btn': '💎 Connect Wallet & Deposit',
  'coinflip.wallet_connected_banner': 'Wallet connected! Deposit TON to play for real.',
  'coinflip.deposit_ton_btn': '💎 Deposit TON',
  'coinflip.keep_demo_hint': 'Or keep flipping in demo mode below ↓',
  'coinflip.pick_heads_aria': 'Pick Heads',
  'coinflip.pick_tails_aria': 'Pick Tails',
  'coinflip.pick_side_prompt': 'Pick a side',
  'coinflip.chip.insufficient_for_tier': 'Not enough balance for stake + fee at the active tier',
  'coinflip.chip.house_coverage_low': 'House coverage too low for this bet right now',
  'coinflip.flip_btn_pick_side': 'Pick a side to flip',
  'coinflip.flip_btn_demo': '🪙 FLIP {stake} {currency}',
  'coinflip.flip_disabled.insufficient': 'Not enough balance for this bet — pick a smaller chip or deposit more.',
  'coinflip.flip_disabled.tier_fee_exceeds': 'Boost/Mega adds a fee — total cost {gross} TON exceeds your balance. Pick a smaller chip, switch to Standard, or deposit more.',
  'coinflip.flip_disabled.limit_unavailable': 'Bet limit unavailable right now — please wait a moment and try again.',
  'coinflip.pf_button_verifiable': 'Every outcome is verifiable — we publish the math',
  'coinflip.pf_button_free_demo': '🎮 Free Demo · No wallet needed · Play for real anytime',
  'coinflip.info.title': 'Why CricketFlip Is Different',
  'coinflip.info.subtitle': 'Built for players, not against them',
  'coinflip.info.custody_title': 'Your Balance Is Held In Custody',
  'coinflip.info.custody_body': 'When you deposit, your TON moves to a hot wallet operated by CricketFlip and your balance is recorded in our ledger. Withdraw any time to your bound wallet — we process the on-chain send.',
  'coinflip.info.locked_title': 'The Result Is Locked Before You Bet',
  'coinflip.info.locked_body': 'For every flip we publish a commit_hash (SHA-256 of a fresh server_seed) BEFORE you submit your stake. Your browser sends its own client_seed. After settlement we reveal the server_seed; you can recompute SHA-256 and the HMAC and check the outcome yourself.',
  'coinflip.info.withdraw_title': 'Withdraw Anytime. Your Full Balance.',
  'coinflip.info.withdraw_body': 'One tap and your full balance heads straight back to your bound wallet. The TON network charges its own gas on the withdrawal.',
  'coinflip.info.verify_dont_trust_title': 'Verify, Don\'t Trust',
  'coinflip.info.verify_dont_trust_body': 'Each flip outcome is signed by our service with an HMAC-SHA256 over (server_seed, client_seed, nonce, choice). Open the Verify tab, paste any Flip ID, and your browser will recompute the result. If we lied, the recompute would not match.',
  'coinflip.info.why_title': 'Why would we do this?',
  'coinflip.info.why_body': 'Because the coinflip is just the start. We\'re building a cricket gaming platform — and the best way to earn your trust is to be provably fair by design and verifiable on every flip. When we build on transparency from day one, imagine what we build when the stakes are higher.',
  'coinflip.info.dismiss_btn': 'Got It — Let Me Flip',
  'deposit.custodial_tooltip': 'Custodial model: your TON is held by CricketFlip and withdrawn on request.',
  'deposit.error.maintenance': 'Deposits are temporarily paused for maintenance. Please retry in a few minutes.',
  'deposit.error.unconfigured': 'Deposits are temporarily unavailable. Use Send feedback in the menu to tell us.',
  'deposit.error.invoice_failed': 'Could not create a deposit invoice. Please retry shortly.',
  'deposit.error.invoice_invalid': 'Server returned an invalid deposit invoice. Please retry shortly.',
  'deposit.error.tx_failed_pre_wallet': 'Transaction failed. Please try again — your TON is still in your wallet.',
  'deposit.title': 'Deposit TON',
  'deposit.subtitle': 'One approval. TON lands in your CricketFlip balance.',
  'deposit.custom_amount_placeholder': 'Or enter amount',
  'deposit.custom_amount_aria': 'Custom deposit amount in TON',
  'deposit.amount_label': 'Amount',
  'deposit.quick_amounts_label': 'Quick amounts',
  'deposit.summary_deposit_label': 'Deposit',
  'deposit.summary_amount': '{amount} TON',
  'deposit.network_fee_note': 'Your wallet pays a small TON network fee separately (paid to validators).',
  'deposit.confirm_btn': 'Deposit {amount} TON',
  'deposit.confirm_btn_empty': 'Enter an amount',
  'deposit.preparing_title': 'Preparing your deposit...',
  'deposit.preparing_sub': 'Generating a one-time invoice',
  'deposit.approve_title': 'Approve in Tonkeeper',
  'deposit.approve_sub': 'Confirm the deposit transaction in your wallet',
  'deposit.confirming_title': 'Confirming on-chain...',
  'deposit.confirming_wait_early': 'Waiting for the network to confirm your deposit...',
  'deposit.confirming_wait_mid': 'Still confirming — this is normal on TON...',
  'deposit.confirming_wait_late': 'Almost there — the network is a bit slow today...',
  'deposit.confirming_safe_note': '💎 Your TON is safe. We credit your balance as soon as we see the deposit.',
  'deposit.done_title': 'Deposited!',
  'deposit.done_credited': '{amount} TON credited to your balance',
  'deposit.delayed_title': 'Awaiting confirmation',
  'deposit.delayed_body': 'Your transaction was approved in your wallet and is on its way. We\'re still waiting for the network to confirm it — TON can take a few minutes. We\'ll credit your balance automatically once it lands.',
  'deposit.delayed_invoice': 'Invoice: {invoiceId}',
  'deposit.check_again_btn': 'Check again',
  'deposit.delayed_no_resend': '💎 Do not send another deposit — this one is already on its way.',
  'deposit.error_funds_safe_note': 'Your TON stays in your wallet until we confirm it on-chain. Nothing is lost.',
  'emergency.status.constructing': 'Constructing transaction...',
  'emergency.status.confirm_wallet': 'Please confirm in your wallet...',
  'emergency.status.force_close_sent': '✅ Force close transaction sent. Settlement after 7-day challenge window expires. Come back after the window closes and tap "Finalize" to complete the withdrawal.',
  'emergency.status.force_close_error': '❌ Transaction failed. Please try again.',
  'emergency.status.constructing_finalize': 'Constructing finalize transaction...',
  'emergency.status.finalize_sent': '✅ Finalization sent. If sufficient bankroll, your TON arrives shortly. If insufficient, your channel transitions to CLAIM_PENDING — settled automatically when bankroll refills.',
  'emergency.status.finalize_error': '❌ Finalization failed. The 7-day challenge window may not be over yet.',
  'emergency.header': 'Server Offline — Force Close Available',
  'emergency.subtitle': 'Trust-minimized escape path. Submit your held receipt; settles after 7-day challenge window. Use this if operator is unresponsive.',
  'emergency.balance_label': 'Your balance (from last receipt)',
  'emergency.channel_nonce': 'Channel #{channelId} · Nonce {nonce}',
  'emergency.btn.sending': 'Sending...',
  'emergency.btn.force_close': 'Force close channel',
  'emergency.btn.finalize': 'Finalize (after 7-day challenge window)',
  'emergency.no_receipts': 'No usable receipts found in this browser. If you played from a different device, your receipts are stored there. The server will recover shortly.',
  'emergency.footer_note': 'Receipt-based Force Close. In extreme bankroll conditions, settlement may be recorded as CLAIM_PENDING and settled automatically when bankroll refills. Claims do not expire.',
  'error_boundary.title': 'Something went wrong',
  'error_boundary.body': 'Your session and balance are safe. The interface hit an unexpected error and couldn\'t continue rendering. Reload to start fresh.',
  'error_boundary.reload_btn': 'Reload',
  'error_boundary.contact_note': 'If this keeps happening, reach out via the Telegram channel so we can look at it.',
  'error_boundary.tech_details_summary': 'Technical details',
  'feedback.error.submit_failed': 'Could not send feedback. Try again later.',
  'feedback.success_title': 'Thanks — we read every one',
  'feedback.success_body': 'Your feedback was received. We won\'t reply through this form.',
  'feedback.title': 'Feedback',
  'feedback.intro': 'Found a bug or have a suggestion? Tell us. We read every submission.',
  'feedback.rating_prompt': 'How was your experience?',
  'feedback.star_aria_singular': '{n} star',
  'feedback.star_aria_plural': '{n} stars',
  'feedback.stars_count': '{stars} of 5',
  'feedback.message_label': 'Message (optional)',
  'feedback.char_counter': '{charCount}/{charLimit}',
  'feedback.message_placeholder': 'Bug report, feature request, anything else...',
  'feedback.safety_reminder': '🔐 Never share your seed phrase, private key, or recovery words. We will never ask for them.',
  'feedback.submit_btn_loading': 'Sending...',
  'feedback.submit_btn': 'Send feedback',
  'header_menu.support.copied_toast': 'Copied · {SUPPORT_EMAIL}',
  'header_menu.more_options_aria': 'More options',
  'header_menu.how_it_works': 'How it works',
  'header_menu.send_feedback': 'Send feedback',
  'header_menu.terms': 'Terms',
  'header_menu.privacy': 'Privacy',
  'header_menu.support': 'Support',
  'history.entry.deposit': 'Deposit',
  'history.entry.flip': 'Flip',
  'history.entry.won': 'Won',
  'history.entry.withdrawal': 'Withdrawal',
  'history.entry.withdrawal_reversed': 'Withdrawal reversed',
  'history.entry.deposit_reversed': 'Deposit reversed',
  'history.entry.refund': 'Refund',
  'history.load_error.title': 'Couldn\'t load your activity',
  'history.load_error.body': 'We couldn\'t reach the server just now. Refresh or check back in a moment.',
  'history.data_error.title': 'Server returned malformed ledger data',
  'history.data_error.body': 'We won\'t display partial or possibly-incorrect activity. Refresh, or use Send feedback in the menu if it persists.',
  'history.loading': 'Loading...',
  'history.stats.flips': 'Flips',
  'history.stats.win_rate': 'Win Rate',
  'history.stats.profit': 'Profit',
  'history.verify_hint': 'Tap any flip below to verify it cryptographically.',
  'history.empty.title': 'No activity yet',
  'history.empty.body': 'Deposit TON and place your first flip to start your history.',
  'history.amount_invalid': 'INVALID',
  'history.flip.bet_context': '· Bet {stakeStr}',
  'history.row.ton_verify': 'TON · verify →',
  'history.row.verify_aria': 'Verify flip {refId}',
  'history.row.flip_aria': '{label} {headText} TON',
  'history.row.entry_aria': '{label} {sign}{tonStr} TON at {timestamp}',
  'history.feedback_footer': 'Found a bug or have feedback? Send it →',
  'leaderboard.placeholder.title': 'Leaderboard returns soon',
  'leaderboard.placeholder.body': 'We\'re rebuilding rankings for the custodial model. Your Standard flips keep accruing in your activity ledger — every flip will count when leaderboards relight.',
  'leaderboard.coming_back': 'Coming back soon',
  'leaderboard.equal_odds.title': 'Equal odds every flip',
  'leaderboard.equal_odds.body': 'Rankings will reflect lifetime ledger activity once relit.',
  'onboarding.slide1.title': 'TON coin flip, instant payouts',
  'onboarding.slide1.desc': 'Pick heads or tails. A Standard win pays 2× your bet; lose and you lose your stake. Boost and Mega pay more for a small fee, shown upfront. That\'s it.',
  'onboarding.slide1.highlight': 'Standard 2× · Boost/Mega pay more',
  'onboarding.slide2.title': 'Withdraw anytime',
  'onboarding.slide2.desc': 'Your balance is yours. Cash out your full balance to your bound wallet whenever you want — one tap. TON network gas applies on withdrawals.',
  'onboarding.slide2.highlight': 'Your balance, your control',
  'onboarding.slide3.title': 'Provably Fair',
  'onboarding.slide3.desc': 'Connect your wallet to play with real TON. Each flip outcome is signed by our service so you can verify it. Verify any flip yourself.',
  'onboarding.slide3.highlight': 'Connect wallet · Verifiable every flip',
  'onboarding.skip': 'Skip',
  'onboarding.next': 'Next',
  'onboarding.start': 'Start Flipping ⚡',
  'settlement.open.label': 'Channel open',
  'settlement.open.description': 'Ready to play. Tap Cash out anytime to settle your balance.',
  'settlement.cooperative_closing.label': 'Cashing out — settling now',
  'settlement.cooperative_closing.description': 'Operator-assisted fast settlement using your current balance.',
  'settlement.force_closing.label': 'Force close in progress',
  'settlement.force_closing.description': 'Settlement after 7-day challenge window expires.',
  'settlement.claim_pending.label': 'Win recorded on-chain. Payout pending bankroll refill.',
  'settlement.claim_pending.description': 'Auto-retry in progress.',
  'settlement.countdown.expired': 'challenge window expired',
  'settlement.countdown.days_hours': '{days}d {hours}h remaining',
  'settlement.countdown.hours_minutes': '{hours}h {minutes}m remaining',
  'settlement.countdown.minutes_seconds': '{minutes}m {seconds}s remaining',
  'settlement.countdown.seconds': '{seconds}s remaining',
  'settlement.unknown_state': 'Unknown state ({state})',
  'verify.error.invalid_uuid': 'Flip ID must be a valid UUID (e.g. 6f5a8b3c-1d2e-4a4f-9c0d-1234567890ab).',
  'verify.error.not_found': 'Flip {id} not found, or it doesn\'t belong to you.',
  'verify.error.fetch_failed': 'Could not verify this flip. Check your connection and try again.',
  'verify.title': 'Provably Fair',
  'verify.subtitle': 'Verify any flip — the math runs in your browser, not ours',
  'verify.input.placeholder': 'Paste Flip ID (UUID)',
  'verify.button.verify': 'Verify',
  'verify.status.pending_body': 'This flip is still being settled. The server seed has not been revealed yet — check back in a moment.',
  'verify.status.failed_body': 'This flip failed before settlement. No funds were debited.',
  'verify.status.failed_refunded_body': 'This flip failed during settlement; the stake was refunded to your balance.',
  'verify.commit_hash_prebet_label': 'Commit hash (pre-bet)',
  'verify.result.picked_result': 'Picked {choice} · Result: {outcome}',
  'verify.error.invalid_stake': 'Invalid stake value from server',
  'verify.status.valid_badge': '✓ VALID',
  'verify.status.mismatch_badge': '✗ MISMATCH',
  'verify.status.matches_badge': '✓ MATCHES',
  'verify.step1.title': 'Commit Integrity',
  'verify.step1.sha256_label': 'SHA-256(server_seed)',
  'verify.step1.precommitted_label': 'Pre-committed commit_hash',
  'verify.step1.valid_msg': '✓ Server seed matches the hash we committed before your flip.',
  'verify.step1.mismatch_msg': '✗ Hash mismatch — server seed does not match the pre-commitment!',
  'verify.step2.title': 'HMAC-SHA256',
  'verify.step2.server_seed_label': 'Server seed (key + msg[0..31], 32 B)',
  'verify.step2.client_seed_label': 'Client seed (msg[32..63], 32 B)',
  'verify.step2.nonce_label': 'Nonce (msg[64..71], uint64 BE)',
  'verify.step2.choice_label': 'Choice (msg[72])',
  'verify.step2.recomputed_label': 'HMAC-SHA256 (recomputed in your browser)',
  'verify.step2.backend_hmac_label': 'Backend-claimed HMAC',
  'verify.step2.valid_msg': '✓ HMAC matches — outcome is deterministic from the four published inputs.',
  'verify.step2.mismatch_msg': '✗ HMAC mismatch — recompute disagrees with the backend!',
  'verify.step3.title': 'Outcome',
  'verify.step3.hmac_lowbit': 'hmac[0] = 0x{hex} · low bit = {bit}',
  'verify.step3.bit_mapping': '0 → {heads}\n1 → {tails}',
  'verify.step4.title': 'Verify Yourself',
  'verify.step4.run_instruction': 'Run in any terminal with Node.js installed:',
  'verify.copy.copied': '✅ Copied!',
  'verify.copy.default': '📋 Copy proof',
  'verify.explainer.summary': 'What am I looking at?',
  'verify.explainer.step_label': 'Step {n} — {title}:',
  'verify.explainer.step1_body': 'The server picks a 32-byte random server_seed and publishes SHA-256(server_seed) as the commit_hash BEFORE you submit your flip. After the flip settles we reveal the server_seed; SHA-256(server_seed) must still equal that pre-committed commit_hash. If it does, the seed wasn\'t picked after the fact.',
  'verify.explainer.step2_body': 'Outcome = HMAC-SHA256(key = server_seed, message = server_seed ‖ client_seed ‖ nonce ‖ choice). You provided the client_seed, the server provided the server_seed, the nonce is locked at flip-request time. Same four inputs always produce the same HMAC — your browser just recomputed it.',
  'verify.explainer.step3_body': 'The low bit of the first HMAC byte determines heads (0) or tails (1). The math is fixed by the four inputs above; there is no other source of randomness.',
  'verify.explainer.step4_body': 'Run the Node command on any machine. You\'ll get the exact same HMAC hex. No CricketFlip server involved.',
  'verify.howitworks.header': 'How Provably Fair Works',
  'verify.howitworks.step1_title': 'We commit a server seed before your flip',
  'verify.howitworks.step2_title': 'You submit your own client seed',
  'verify.howitworks.step3_title': 'Outcome = HMAC-SHA256(seed, msg)',
  'verify.howitworks.step4_title': 'Anyone can recompute it forever',
  'verify.howitworks.step1_desc': 'A 32-byte random server_seed is generated. We publish SHA-256(server_seed) as the commit_hash. That hash is locked the moment you press Flip — we cannot change the seed after.',
  'verify.howitworks.step2_desc': 'Your browser generates a 32-byte client_seed at flip time and sends it with your choice. You control half of the randomness; we cannot predict what you will send.',
  'verify.howitworks.step3_desc': 'HMAC of (server_seed ‖ client_seed ‖ nonce ‖ choice) keyed by server_seed. The low bit of byte[0] is your outcome. Deterministic. No hidden randomness.',
  'verify.howitworks.step4_desc': 'We reveal the server_seed after settlement. Your browser recomputes SHA-256 + HMAC and shows you the result. Match = honest. Mismatch = caught.',
  'verify.tagline': '"The only coinflip that\'s provably fair by design"',
  'deposit.amount_error.too_precise': 'Up to 9 decimal places',
  'deposit.amount_error.invalid_amount': 'Enter a valid TON amount',
  'deposit.amount_error.below_min': 'Minimum deposit is {min} TON',
  'deposit.amount_error.above_max': 'Maximum deposit is {max} TON',
  'cta.flip_standard': '🪙 FLIP {stake} TON',
  'cta.flip_boost_mega': '{prefix} {label} +{fee} → Win {win} TON',
  'cta.base_summary': 'Bet {stake} → Win {stake_x2} TON',
  'error.session_timeout_title': 'Reconnect needed',
  'error.session_timeout_message': 'Your secure session timed out. Please reopen CricketFlip from Telegram to continue.',
  'legal.english_controlling_notice': 'This page is available in English only. The English version is the controlling version.',
  'tier.standard': 'Standard',
  'tier.boost': 'Boost',
  'tier.mega': 'Mega',
  'withdraw.confirm.title': 'Withdraw',
  'withdraw.confirm.you_receive': 'You receive',
  'withdraw.confirm.balance_ton': '{amount} TON',
  'withdraw.confirm.to_your_wallet': 'To your wallet',
  'withdraw.confirm.no_fees': 'Full balance — no fees deducted',
  'withdraw.confirm.cta': 'Withdraw {amount} TON',
  'withdraw.processing.title': 'Withdrawing...',
  'withdraw.processing.queueing': 'Queueing your withdrawal...',
  'withdraw.processing.submitting': 'Submitting on-chain...',
  'withdraw.processing.awaiting_confirmation': 'Awaiting confirmation...',
  'withdraw.processing.reassurance': 'Your TON is safe and on its way to your wallet.',
  'withdraw.queued.title': 'Withdrawal in progress',
  'withdraw.queued.result_msg': 'Your withdrawal is in progress — you can track it anytime in History.',
  'withdraw.queued.footer': 'You can follow your withdrawal anytime in History.',
  'withdraw.review.title': 'On its way!',
  'withdraw.review.result_msg': 'Your withdrawal is on its way to your wallet 🚀',
  'withdraw.success.title': 'Withdrawal sent',
  'withdraw.success.result_msg': '{amount} TON sent to your wallet',
  'withdraw.success.explorer_link': 'View on TON Explorer →',
  'withdraw.success.footer': 'Sent straight to your bound wallet.',

  // ── CF-BONUS-V3-WITHDRAW-WARNING-V1 ────────────────────────────────────────
  // A cash withdrawal while a bonus is active VOIDS the bonus in the same backend
  // transaction and cannot be undone. Until this shipped, nothing in the app said so.
  // Copy rules: name the exact amount at risk, never imply the chips survive, and never
  // imply we are withholding the player's own cash — their cash is always theirs.
  'withdraw.bonus.at_risk_label': 'Your bonus chips',
  'withdraw.bonus.forfeit_warning': 'You still have {amount} TON in bonus chips. Withdrawing now closes them.',
  'withdraw.bonus.unlock_hint': 'You\'re {amount} TON of Boost or Mega play from unlocking them as real cash.',
  'withdraw.bonus.keep_cta': 'Keep playing',
  'withdraw.bonus.forfeit_cta': 'Withdraw anyway',
  'withdraw.bonus.checking': 'Checking your bonus…',
  'withdraw.bonus.blocked_title': 'We can\'t check your bonus right now',
  'withdraw.bonus.blocked_body': 'Withdrawing could cancel bonus chips without warning you, so we\'ve paused it. Your balance is untouched — please try again in a moment.',
  'withdraw.bonus.retry': 'Try again',
  'withdraw.error.title': 'Withdrawal didn\'t go through',
  'withdraw.error.reassurance': 'Your balance is safe — give it another try. If it keeps happening, use Send feedback in the menu.',
  'withdraw.error.failed_default': 'Withdrawal failed. Your balance is safe.',
  'withdraw.error.reversed': 'Withdrawal could not be delivered and the amount was credited back to your balance.',
  'withdraw.error.network': 'Network error. Your balance is safe — try again.',
  'withdraw.error.missing_id_accepted': 'Your withdrawal was accepted. Use Send feedback in the menu if you need us to check the tracking details.',
  'withdraw.error.maintenance_mode': 'Withdrawals are temporarily paused for maintenance. Please retry in a few minutes.',
  'withdraw.error.insufficient_balance': 'Insufficient balance for this withdrawal.',
  'withdraw.error.temporary_insolvency_protection': 'We could not process this withdrawal right now — your balance is fully safe. Please try again in a few minutes.',
  'withdraw.error.invalid_dest_address': 'Destination wallet is not a valid TON address.',
  'withdraw.error.hot_wallet_balance_unavailable': 'Brief network hiccup — tap Withdraw again. Your balance is safe.',
  'withdraw.error.hot_wallet_unconfigured': 'Withdrawals are briefly unavailable right now. Please try again in a little while.',
  'withdraw.error.invalid_request': 'Invalid withdrawal request. Please try again.',
  'withdraw.balance_invalid.title': 'We can\'t show your balance right now',
  'withdraw.balance_invalid.body': 'Your funds are safe — we just couldn\'t read a reliable balance to withdraw right now. Please close this and try again from the home screen. If it keeps happening, use Send feedback in the menu.',

  // ── CF-BONUS Ticket B — first-deposit bonus ────────────────────────────────
  // Copy is PL-approved + Scorer content-reviewed (plans/CF-BONUS-TERMS-V1-DRAFT.md).
  // Translations MUST preserve, in every locale: the D1 forfeiture (withdrawing cancels
  // remaining chips), the D2 excess-forfeit (conversion capped at the bonus issued),
  // Boost/Mega-ONLY contribution, the fee mention, the advisory nature of availability,
  // and "qualifying" on the deposit. Key parity alone does NOT prove any of that survived —
  // see tests/cf-bonus-i18n-semantics.spec.ts (Scorer amendment 6).
  // No markdown emphasis: the terms renderer prints '**' literally.
  'bonus.teaser.headline': '100% First Deposit Bonus up to 10 TON',
  'bonus.teaser.body': 'Your first deposit is matched in Bonus Chips, up to 10 TON. Wagering terms apply.',
  'bonus.teaser.availability': 'Eligibility and availability are confirmed when your deposit is credited.',
  'bonus.teaser.terms_link': 'Bonus terms',

  'bonus.terms.title': '100% First Deposit Bonus up to 10 TON',
  'bonus.terms.pt1': 'Make your first ever deposit and receive a matching amount in Bonus Chips, up to 10 TON. Example: deposit 5 TON and you get 5 TON in Bonus Chips on top.',
  'bonus.terms.pt2': 'Bonus Chips are play credit: they are used first when you flip, before your cash. They cannot be withdrawn directly.',
  'bonus.terms.pt3': 'To unlock a cash conversion, wager 10 times your bonus amount on Boost or Mega flips — these are the flips that count toward it, and they carry their usual fees. Example: a 10 TON bonus needs 100 TON of Boost or Mega play.',
  'bonus.terms.pt4': 'When you complete wagering, your remaining Bonus Chips — including any winnings attributed to them — convert to withdrawable cash up to the bonus issued. Any Bonus Chip balance above your original bonus amount is forfeited at conversion: the maximum that can convert to cash is the bonus you were given. If you lose the chips, stop before 10 times, or the seven-day period ends, you may receive no cash conversion.',
  'bonus.terms.pt5': 'Your own cash is not locked by the bonus. Withdrawing it before your wagering is complete cancels your remaining Bonus Chips — they are forfeited at that moment.',
  'bonus.terms.pt6': 'The bonus expires 7 days after it is granted. Unused Bonus Chips are removed at expiry.',
  'bonus.terms.pt7': 'One bonus per player and per wallet, on your confirmed, invoice-matched first deposit only. Deposits from a wallet that has deposited before, under any account, do not qualify.',
  'bonus.terms.pt8': 'You will see the offer while bonus grants are available. Eligibility and availability are confirmed when your deposit is credited; your qualifying deposit is credited in full whether or not a bonus is granted.',
  'bonus.terms.pt9': 'We may pause or end the campaign for new bonuses at any time. Bonuses already granted keep their full terms.',

  'bonus.active.title': 'Your bonus',
  'bonus.active.chips_label': 'Bonus Chips',
  'bonus.active.chips_note': 'Used first when you flip, before your cash.',
  'bonus.active.progress_label': 'Wagering progress',
  'bonus.active.progress_detail': '{done} / {target} TON on Boost or Mega flips',
  'bonus.active.remaining': '{amount} TON of Boost or Mega play left to unlock your conversion',
  'bonus.active.complete': 'Wagering complete',
  'bonus.active.expires_in': 'Expires in {time}',
  'bonus.active.expired_note': 'This bonus has reached its expiry time.',

  'bonus.time.days_hours': '{days}d {hours}h',
  'bonus.time.hours_mins': '{hours}h {mins}m',
  'bonus.time.mins': '{mins}m',

  'bonus.terminal.converted_title': 'Bonus complete',
  'bonus.terminal.converted_body': '{amount} TON converted to withdrawable cash.',
  'bonus.terminal.converted_zero': 'This bonus closed without a cash conversion.',
  'bonus.terminal.expired_title': 'Bonus expired',
  'bonus.terminal.expired_body': 'The 7-day period ended and any remaining Bonus Chips were removed.',
  'bonus.terminal.voided_title': 'Bonus closed',
  'bonus.terminal.voided_body': 'Your remaining Bonus Chips were cancelled when you withdrew before wagering was complete.',

  // A1 (Scorer): a failed read is OUR ignorance, never a statement that the player has no
  // bonus. It must not claim the chips are intact either — they may genuinely have been
  // voided or expired. The only honest claim is that reading never mutates.
  'bonus.unavailable.title': 'Bonus status temporarily unavailable',
  'bonus.unavailable.body': 'We couldn\'t load your bonus status right now. This is a display problem only — reading your status never changes it. Please try again in a moment.',
  'growth.ticker.win': 'A player just won {amount} TON',
};
